import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";

const Datenschutz = () => {
  return (
    <div className="min-h-screen py-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl">
        {/* Header */}
        <div className="text-center space-y-4 mb-16">
          <Badge className="bg-blue-100 text-blue-800">Datenschutzerklärung</Badge>
          <h1 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Datenschutz
          </h1>
          <p className="text-lg text-gray-600">
            Informationen zur Erhebung und Verwendung personenbezogener Daten
          </p>
        </div>

        <div className="prose prose-lg max-w-none">
          <Card className="mb-8">
            <CardHeader>
              <CardTitle>1. Verantwortlicher</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                Verantwortlicher für die Datenverarbeitung auf dieser Website ist:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p><strong>NetSyTe - Netzwerk System Technik</strong><br />
                [Ihr Name / Geschäftsführer]<br />
                [Straße und Hausnummer]<br />
                [PLZ und Ort]<br />
                Deutschland</p>
                <p className="mt-2">
                  <strong>Telefon:</strong> +49 (0) 123 456 7890<br />
                  <strong>E-Mail:</strong> info@netsyte.de
                </p>
              </div>
            </CardContent>
          </Card>

          <Card className="mb-8">
            <CardHeader>
              <CardTitle>2. Erhebung und Speicherung personenbezogener Daten</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <h3 className="text-lg font-semibold">2.1 Beim Besuch der Website</h3>
              <p>
                Bei der Nutzung unserer Website werden automatisch Informationen erhoben, 
                die Ihr Browser an unseren Server übermittelt. Dies sind:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>IP-Adresse</li>
                <li>Datum und Uhrzeit der Anfrage</li>
                <li>Inhalt der Anforderung (konkrete Seite)</li>
                <li>Zugriffsstatus/HTTP-Statuscode</li>
                <li>Übertragene Datenmenge</li>
                <li>Website, von der die Anforderung kommt</li>
                <li>Browser und Betriebssystem</li>
              </ul>
              <p>
                Diese Daten werden zur Gewährleistung der Funktionsfähigkeit und Sicherheit 
                unserer Website erhoben. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
              </p>

              <h3 className="text-lg font-semibold mt-6">2.2 Kontaktformular</h3>
              <p>
                Bei der Nutzung unseres Kontaktformulars erheben wir folgende Daten:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Name</li>
                <li>E-Mail-Adresse</li>
                <li>Unternehmen (optional)</li>
                <li>Telefonnummer (optional)</li>
                <li>Nachricht</li>
              </ul>
              <p>
                Diese Daten verwenden wir ausschließlich zur Bearbeitung Ihrer Anfrage. 
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.
              </p>
            </CardContent>
          </Card>

          <Card className="mb-8">
            <CardHeader>
              <CardTitle>3. Zweck der Datenverarbeitung</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>Die Verarbeitung Ihrer personenbezogenen Daten erfolgt zu folgenden Zwecken:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Bereitstellung und Funktionsfähigkeit der Website</li>
                <li>Bearbeitung von Anfragen über das Kontaktformular</li>
                <li>Kommunikation im Rahmen der Geschäftsbeziehung</li>
                <li>Erfüllung rechtlicher Verpflichtungen</li>
                <li>Schutz vor Missbrauch und Betrug</li>
              </ul>
            </CardContent>
          </Card>

          <Card className="mb-8">
            <CardHeader>
              <CardTitle>4. Weitergabe von Daten</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                Eine Übermittlung Ihrer personenbezogenen Daten an Dritte findet nicht statt, 
                außer wenn:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Sie ausdrücklich eingewilligt haben (Art. 6 Abs. 1 lit. a DSGVO)</li>
                <li>Dies zur Erfüllung eines Vertrags erforderlich ist (Art. 6 Abs. 1 lit. b DSGVO)</li>
                <li>Eine rechtliche Verpflichtung besteht (Art. 6 Abs. 1 lit. c DSGVO)</li>
                <li>Dies zur Wahrung berechtigter Interessen erforderlich ist (Art. 6 Abs. 1 lit. f DSGVO)</li>
              </ul>
            </CardContent>
          </Card>

          <Card className="mb-8">
            <CardHeader>
              <CardTitle>5. Speicherdauer</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                <strong>Server-Logfiles:</strong> Werden nach 7 Tagen automatisch gelöscht.
              </p>
              <p>
                <strong>Kontaktanfragen:</strong> Werden nach vollständiger Bearbeitung und Ablauf 
                etwaiger Gewährleistungsfristen gelöscht, spätestens nach 3 Jahren.
              </p>
              <p>
                <strong>Geschäftskommunikation:</strong> Wird gemäß den handels- und steuerrechtlichen 
                Aufbewahrungsfristen gespeichert (bis zu 10 Jahre).
              </p>
            </CardContent>
          </Card>

          <Card className="mb-8">
            <CardHeader>
              <CardTitle>6. Ihre Rechte</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Auskunftsrecht (Art. 15 DSGVO):</strong> Sie können Auskunft über die von uns verarbeiteten Daten verlangen.</li>
                <li><strong>Berichtigungsrecht (Art. 16 DSGVO):</strong> Sie können die Berichtigung unrichtiger Daten verlangen.</li>
                <li><strong>Löschungsrecht (Art. 17 DSGVO):</strong> Sie können die Löschung Ihrer Daten verlangen.</li>
                <li><strong>Einschränkungsrecht (Art. 18 DSGVO):</strong> Sie können die Einschränkung der Verarbeitung verlangen.</li>
                <li><strong>Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie können die Übertragung Ihrer Daten verlangen.</li>
                <li><strong>Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie können der Verarbeitung widersprechen.</li>
              </ul>
              <p className="mt-4">
                Zur Geltendmachung Ihrer Rechte wenden Sie sich bitte an: 
                <strong> datenschutz@netsyte.de</strong>
              </p>
            </CardContent>
          </Card>

          <Card className="mb-8">
            <CardHeader>
              <CardTitle>7. Beschwerderecht</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                Sie haben das Recht, sich bei einer Aufsichtsbehörde zu beschweren, 
                wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen 
                die DSGVO verstößt.
              </p>
              <p>
                Zuständige Aufsichtsbehörde für NetSyTe ist der Landesbeauftragte für 
                den Datenschutz des Bundeslandes, in dem unser Unternehmen seinen Sitz hat.
              </p>
            </CardContent>
          </Card>

          <Card className="mb-8">
            <CardHeader>
              <CardTitle>8. Cookies und ähnliche Technologien</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                Unsere Website verwendet nur technisch notwendige Cookies, die für die 
                Funktionsfähigkeit der Website erforderlich sind. Diese Cookies werden 
                automatisch beim Schließen des Browsers gelöscht.
              </p>
              <p>
                Wir verwenden keine Tracking-Cookies oder ähnliche Technologien für 
                Werbezwecke oder Analyse.
              </p>
            </CardContent>
          </Card>

          <Card className="mb-8">
            <CardHeader>
              <CardTitle>9. SSL-Verschlüsselung</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                Diese Website nutzt zur Gewährleistung der Sicherheit der Datenverarbeitung 
                und zum Schutz der Übertragung vertraulicher Inhalte eine SSL-Verschlüsselung. 
                Eine verschlüsselte Verbindung erkennen Sie daran, dass in der Adresszeile 
                des Browsers "https://" angezeigt wird.
              </p>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>10. Änderungen der Datenschutzerklärung</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf zu aktualisieren, 
                um sie an geänderte Rechtslagen oder bei Änderungen unserer Leistungen 
                anzupassen. Für Ihren nächsten Besuch gilt dann die neue Datenschutzerklärung.
              </p>
              <p className="text-sm text-gray-600">
                <strong>Stand:</strong> Dezember 2024
              </p>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;